// Source: app/scripts/controllers/lot-item.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('LotItemController', [
  '$scope',
  '$filter',
  '$modal',
  'toaster',
  'AuctionParticipationRequest',
  function ($scope, $filter, $modal, toaster, AuctionParticipationRequest) {
    Stomp("/topic/lot/", $scope.entity.id, subscribeForLot, $scope);

    function subscribeForLot(lot) {
      $scope.$apply(function () {
        $scope.entity.status = lot.status;
      });
    }

    $scope.modalSend = $modal({
      scope: $scope,
      template: 'forms/modals/send_lot_request.html',
      show: false
    });

    $scope.registerForAuction = function (lotDto) {
      $scope.requestEntity = {
        lot: {
          id: lotDto.lot.id
        },
        auction: lotDto.lot.auction
      };
      $scope.req = {
        lotDto: lotDto
      };
      $scope.modalSend.show();
    };


    $scope.sendLotRequest = function () {
      AuctionParticipationRequest.sendRequest($scope.requestEntity, function () {
        delete $scope.requestEntity;
        $scope.modalSend.hide();
        load();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("eauction.request_sent"));
      }, function () {
        load();
      });
    };

  }
]);
